import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getPartsCriticality = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/parts-criticality`);
    return response.data;
  } catch (error) {
    console.error('Error fetching parts criticality:', error.response?.data || error);
    throw error;
  }
};

export const getPartsCriticalityById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/parts-criticality/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching parts criticality:', error.response?.data || error);
    throw error;
  }
};

export const createPartsCriticality = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/parts-criticality`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating parts criticality:', error.response?.data || error);
    throw error;
  }
};

export const updatePartsCriticality = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/parts-criticality/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating parts criticality:', error.response?.data || error);
    throw error;
  }
};

export const deletePartsCriticality = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/parts-criticality/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting parts criticality:', error.response?.data || error);
    throw error;
  }
};
